import React from "react";
import RoomSizeListTable from "./Components/RoomSizeListTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const RoomSizeList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Room Size List</HeadingOne>
          <AddItemBtn url="add-room-size" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <RoomSizeListTable />
      </div>
    </PageBody>
  );
};

export default RoomSizeList;
